import { IconButton, Tooltip } from "@mui/material";
import { Zap } from "../../shared/components/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useMemo } from "react";

export const OptionalRedirect = () => {
    const { optionalRedirect } = useSelector((state: RootState) => state.app.settings);
    const targetUrl = useMemo(() => {
        if (!optionalRedirect?.urlRewriteRules?.length) return null;

        return optionalRedirect.urlRewriteRules.reduce(
            (acc, elem) => acc.replace(new RegExp(elem.match), elem.replacement),
            window.location.href
        );
    } , [optionalRedirect, window.location.href]);

    if (!optionalRedirect || !targetUrl) return null;

    return (
        <Tooltip title={optionalRedirect.message} arrow>
            <a href={targetUrl} rel="noopener noreferrer">
                <IconButton id="btn-optional-redirect">
                    <Zap size="small" />
                </IconButton>
            </a>
        </Tooltip>
    );
}